import { has } from 'underscore';
import { $current } from '@bingads-webui-react/scope-service';
import { getRoutePathById, Configs } from '@bingads-webui-campaign-react/with-site-map';
import { Scope } from '@bingads-webui-campaign-react/shell-ui-common';

export function breadcrumbClickHandler(breadcrumbScope, routerScope, siteMap) {
  switch (breadcrumbScope) {
    case Scope.Account:
      routerScope.remove(['campaignId', 'adGroupId']);
      break;
    case Scope.Campaign:
      routerScope.remove(['adGroupId']);
      break;
    default: break;
  }

  // align with google, click account scope link will show campaigns grid
  const route = breadcrumbScope === Scope.Account
    ? getRoutePathById(Configs.campaignSiteMap, 'campaigns')
    : getRoutePathById(siteMap, 'ads');
  if (has(routerScope.values, 'adId')) {
    routerScope.remove(['adId']);
    routerScope.save(route);
  } else if (breadcrumbScope === Scope.Account) {
    routerScope.save(route);
  } else {
    routerScope.save();
  }
}

export function campaignClickHandler(event, campaignId, scope) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  scope.set({
    cid: $current,
    aid: $current,
    uid: $current,
    campaignId,
  });

  scope.save();
  return false;
}

export function getCampaignUrl(campaignId, scope) {
  const { cid, aid, uid } = scope.values;
  return `${scope.location.pathname}?uid=${uid}&cid=${cid}&aid=${aid}&campaignId=${campaignId}`;
}

export function pageClickHandler(siteMap, scope, targetPage) {
  scope.save(getRoutePathById(siteMap, targetPage));
}
